(function(){
    angular
        .module('app')
        .directive('ngSelect2', select2);

        select2.$inject = ['$timeout','$parse'];
        function select2($timeout,$parse){
            return {
              restrict: 'AE',
              require: 'ngModel',
              scope:{
                options:"="
              },
            link: function (scope, element, attrs, ngModel) {
                
                  var options = {};
                  console.log(scope)
                  console.log(scope.options);
                  console.log(attrs);
                  if(scope.options){
                    options = scope.options;
                  }
                  //console.log(scope.options);
            
                  $timeout(function() {
                    element.select2(options);
                    element.select2Initialized = true;
                  });

                    
                    scope.$on("refresh_select2", function(evt,data){ 
                        $timeout(function () {
                          element.trigger('change');
                        });
                    });

                    scope.$on("recreate_select2", function(evt,data){ 
                        $timeout(function() {
                          element.select2('destroy');
                          element.select2();
                        });
                    });

                    var refreshSelect = function() {
                        if (!element.select2Initialized) return;
                        $timeout(function() {
                              element.trigger('change');
                        });
                    };
      
                    var recreateSelect = function () {
                        if (!element.select2Initialized) return;
                        $timeout(function() {
                          element.select2('destroy');
                          element.select2();
                        });
                    };

                    scope.$watch(attrs.ngModel, refreshSelect);

                    if (attrs.ngOptions) {
                        var list = attrs.ngOptions.match(/ in ([^ ]*)/)[1];
                              // watch for option list change
                            scope.$watch(list, recreateSelect);
                    }

                    if (attrs.ngDisabled) {
                        scope.$watch(attrs.ngDisabled, refreshSelect);
                    }

                    element.bind("$destroy", function() {
                        element.select2("destroy");
                    });

                    attrs.$observe('disabled', function (value) {
                       element.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                       element.select2('readonly', !!value);
                    });


                
            }
          };
      }
})();